import React from "react";
import { Box, Heading, IconTick, Span } from "@catchoftheday/cg-components";
import { BenefitItemZone } from "../../layouts/UpsellModalLayout/UpsellModalLayout";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BENEFIT_ITEMS = ["Free delivery on eligible products or orders at all OnePass retail brands", "Member-only pricing on thousands of products at Catch", "Access to weekly exclusive member deals at Catch"];
export var BenefitItem = function BenefitItem(_ref) {
  var children = _ref.children;
  return ___EmotionJSX(BenefitItemZone, null, ___EmotionJSX(Box, {
    alignSelf: "center"
  }, ___EmotionJSX(IconTick, {
    width: "1.25em",
    mr: 2,
    color: "inherit"
  })), ___EmotionJSX(Span, {
    fontSize: "inherit",
    fontWeight: "medium"
  }, children));
};
export var Benefits = function Benefits() {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading.h3, {
    fontWeight: "bold",
    textTransform: "capitalize",
    m: 0
  }, "OnePass Member Benefits:"), ___EmotionJSX(Box, {
    mb: 6
  }, BENEFIT_ITEMS.map(function (text, index) {
    return ___EmotionJSX(BenefitItem, {
      key: "upsell-modal-benefit-".concat(index)
    }, text);
  })));
};